"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TimerStrategyImpl {
    constructor(cache, timer) {
        this.isOffline = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.request = async (key, getRequest) => {
            const val = await (getRequest === null || getRequest === void 0 ? void 0 : getRequest());
            if (val) {
                await this.cache.setObject(key, val).asPromise();
            }
            // TODO: Dumb casting to generic, needs to be verified
            return val;
        };
        this.cache = cache;
        this.timer = timer;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async get(key, getRequest) {
        if (!this.isOffline && this.timer.fetch(key) && getRequest) {
            return this.request(key, getRequest);
        }
        try {
            return (await this.cache.getObject(key).asPromise());
        }
        catch (e) {
            if (!this.isOffline) {
                return this.request(key, getRequest);
            }
            throw e;
        }
    }
    goCacheOnly() {
        this.isOffline = true;
        this.timer.stop();
    }
    goRegular() {
        this.isOffline = false;
        this.timer.start();
    }
}
exports.default = TimerStrategyImpl;
//# sourceMappingURL=TimerStrategyImpl.js.map